import { ProductCategoryType } from "@hubcapp/types";

export const productCategoryTypeToCategoryTitle = (
  type?: ProductCategoryType,
  options?: {
    fullDitName?: boolean;
    fullMotabilityName?: boolean;
  },
) => {
  if (type === ProductCategoryType.PreTest) {
    return "Pre-test";
  }
  if (type === ProductCategoryType.PostTest) {
    return "Post-test";
  }
  if (type === ProductCategoryType.Motability2015) {
    return options?.fullMotabilityName ? "Motability 2015" : "Motability";
  }
  if (type === ProductCategoryType.Motability2018) {
    return options?.fullMotabilityName ? "Motability 2018" : "Motability";
  }
  if (type === ProductCategoryType.DitCar) {
    return options?.fullDitName ? "DIT in car" : "DIT";
  }
  if (type === ProductCategoryType.DitClassroom) {
    return options?.fullDitName ? "DIT classroom" : "DIT";
  }

  return "";
};
